import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[dialogFooter]',
})
export class DialogFooter {
  constructor(public templateRef: TemplateRef<any>) {}
}
